// Shared formatting helpers used across portfolio / trading UI.
export const fmtUsd = (n, digits = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtPct = (n, digits = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  const v = Number(n);
  const s = v >= 0 ? "+" : "";
  return `${s}${v.toFixed(digits)}%`;
};

export const fmtQty = (n, symbol) => {
  if (n === null || n === undefined) return "—";
  const isCrypto = /-USD$|-USDT$/i.test(symbol || "");
  return Number(n).toLocaleString(undefined, {
    maximumFractionDigits: isCrypto ? 8 : 4,
  });
};

export const isCryptoSymbol = (s) => /-USD$|-USDT$/i.test(s || "");
